var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-lable-box",class:_vm.show ? 'hide' : ''},[_c('el-divider',{attrs:{"direction":"vertical"}}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }